import './index.scss';
import './index.erb';
import 'components/select';

(function ($) {
  'use strict';

  const $context = $('.q-widget-meet');
  const $ctaContainer = $('.q-cta-container', $context);
  const a = $('a', $ctaContainer);
  const checkoutUrl = a.attr('href');

  $('.q-select-input', $context).qselect('on', 'change', function (value, $el) {
    const options = $el.qselect('getOptions');
    const selectedOption = options.find((item) => item.value === value);
    const offerParams = value;

    $ctaContainer.addClass('active');
    $('.q-title', $ctaContainer).html(`Raio X completo ${selectedOption.text}`);
    a.attr('href', checkoutUrl.concat(offerParams));
  });

  $('.js-select-type', $context).on('click', function () {
    $('.js-select-type', $context).removeClass('active');
    $('.q-cta-container', $context).removeClass('active');
    $('.q-price-action', $context).hide();

    $(this).addClass('active');
    const { klass, price } = $(this).data();

    $('.q-cta-price', $context).text(`R$ ${price}`);
    $(klass).show();
  });
})(jQuery);
